import { render, staticRenderFns } from "./footer-layout.vue?vue&type=template&id=637344ff&scoped=true"
import script from "./footer-layout.vue?vue&type=script&lang=js"
export * from "./footer-layout.vue?vue&type=script&lang=js"
import style0 from "./footer-layout.vue?vue&type=style&index=0&id=637344ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637344ff",
  null
  
)

export default component.exports